/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SetCategoryArticleMappingPayload = {
    /**
     * External article ID from the accounting provider
     */
    externalArticleId: string;
    /**
     * Type of mapping: category (main price) or outage_fee (Ausfallhonorar)
     */
    mappingType?: SetCategoryArticleMappingPayload.mappingType;
    /**
     * Quantity of this article to include on invoices
     */
    quantity?: number;
};
export namespace SetCategoryArticleMappingPayload {
    /**
     * Type of mapping: category (main price) or outage_fee (Ausfallhonorar)
     */
    export enum mappingType {
        CATEGORY = 'category',
        OUTAGE_FEE = 'outage_fee',
    }
}

